"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewSL = void 0;
function viewSL() {
    return {
        constructor: function (props) { },
        mounted: function () { },
        events: {
            onFileUploadSuccess: this.props.onFileUploadSuccess,
            onFileUploadError: this.props.onFileUploadError,
            onFileDelete: this.props.onFileDelete,
            onAdditionalAttachmentCreate: this.props.onAdditionalAttachmentCreate
        }
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/2c51a2fe812ded8e/src/.tmp/ApplicationWorkflowAdditionalAttachments/ViewSL.js
// module id = 350
// module chunks = 0 2